module.exports = __webpack_public_path__ + "img/privacy_background.2133a6a4.svg";